export enum NotificationType {
    Success = 'success',
    Error = 'error',
    Info = 'info',
}
